// Dashboard Color Palette
// Based on UI design specifications

// Primary Blues
export const SEASHORE_BLUE = '#0A3696';      // RGB: 10, 54, 150 - Used for titles, header background
export const ZIMA_BLUE = '#11BBED';          // RGB: 17, 187, 237 - Used for blue values/numbers
export const AQUA_MARINE = '#1AE8DE';        // RGB: 26, 232, 221 - Accent color

// Greens
export const WINTER_GREEN = '#1AE882';       // RGB: 26, 233, 130 - Used for green values, "Fixed" status
export const COOL_GREEN = '#37B362';         // RGB: 55, 179, 98 - Alternative green for charts

// Status Colors (for Current Status & Workflow Trend charts)
export const STATUS_TO_BE_LOCATED = '#FFB85E';  // Peanut Butter Orange
export const STATUS_LOCATED = '#6D39B3';        // Purple Emperor
export const STATUS_TO_BE_FIXED = '#228CDB';    // Blue Vacation
export const STATUS_FIXED = '#1AE882';          // Winter Green

// Accent Colors
export const PEANUT_BUTTER_ORANGE = '#FFB85E';  // RGB: 255, 184, 94
export const DESERT_FLOWER = '#FF8782';         // RGB: 255, 135, 130 - Coral/salmon for alerts
export const PURPLE_EMPEROR = '#6D39B3';        // RGB: 109, 57, 179
export const BLUE_VACATION = '#228CDB';         // RGB: 34, 140, 219

// Neutral Colors
export const CEREBRAL_GREY = '#CCCCCC';         // RGB: 204, 204, 204
export const DARK_GREY = '#666666';             // For secondary text
export const TEXT_PRIMARY = '#333333';          // For primary text

// Transparency variants for Leak Detection/Repair Time charts
export const CHART_BAR_PRIMARY = '#456a8a';              // Current blue
export const CHART_BAR_PRIMARY_LIGHT = 'rgba(69, 106, 138, 0.6)';  // 1st level transparency (legacy)
export const PEANUT_BUTTER_ORANGE_LIGHT = 'rgba(255, 184, 94, 0.7)';  // Peanut Butter Orange with transparency for time charts
export const BLUE_VACATION_LIGHT = 'rgba(34, 140, 219, 0.7)';  // Blue Vacation with 1st level transparency for Leak Repair Time

// Gradient (45 degrees): SEASHORE_BLUE -> ZIMA_BLUE -> AQUA_MARINE
export const GRADIENT_START = SEASHORE_BLUE;    // 0%
export const GRADIENT_MIDDLE = ZIMA_BLUE;       // 50%
export const GRADIENT_END = AQUA_MARINE;        // 100%

// Font Family
export const FONT_FAMILY = '"Albert Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
export const FONT_FAMILY_TITLE = '"Albert Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

// Export as default object for convenience
const dashboardColors = {
  // Primary
  seashoreBlue: SEASHORE_BLUE,
  zimaBlue: ZIMA_BLUE,
  aquaMarine: AQUA_MARINE,

  // Greens
  winterGreen: WINTER_GREEN,
  coolGreen: COOL_GREEN,

  // Status colors
  status: {
    toBeLocated: STATUS_TO_BE_LOCATED,
    located: STATUS_LOCATED,
    toBeFixed: STATUS_TO_BE_FIXED,
    fixed: STATUS_FIXED,
  },

  // Accents
  peanutButterOrange: PEANUT_BUTTER_ORANGE,
  desertFlower: DESERT_FLOWER,
  purpleEmperor: PURPLE_EMPEROR,
  blueVacation: BLUE_VACATION,

  // Neutrals
  cerebralGrey: CEREBRAL_GREY,
  darkGrey: DARK_GREY,
  textPrimary: TEXT_PRIMARY,

  // Charts
  chartBarPrimary: CHART_BAR_PRIMARY,
  chartBarPrimaryLight: CHART_BAR_PRIMARY_LIGHT,
  blueVacationLight: BLUE_VACATION_LIGHT,

  // Fonts
  fontFamily: FONT_FAMILY,
  fontFamilyTitle: FONT_FAMILY_TITLE,
};

export default dashboardColors;
